module.exports = __webpack_public_path__ + "img/FAQ.18645779.svg";